import React from "react";
import { Box, Button } from "@mui/material";
import AxionControls from "../../../components/controls/AxionControls";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import Controls from "../../../components/controls/Controls";

export default function AddEditProductionItemDialog(props) {

    return (
        <Box 
            sx={{
                p:1,
                m:1
            }}>
                <Box sx={{width: 400}}>
                    <AxionControls.AxionTextBox 
                        name="itemNo"
                        label={<FormattedMessage {...messages.itemNoColumnLabel} />}
                        value={props.productionItem.itemNo}
                        onChange={props.onChange}
                    />
                </Box>
                <Box sx={{width: 400}}>
                    <AxionControls.AxionTextBox 
                        name="name"
                        label={<FormattedMessage {...messages.nameColumnLabel} />}
                        value={props.productionItem.name}
                        onChange={props.onChange}
                    />
                </Box>
                <Box sx={{width: 400}}>
                    <AxionControls.AxionTextBox 
                        name="idealCycleTime"
                        label={<FormattedMessage {...messages.idealCycleTimeColumnLabel} />}
                        value={props.productionItem.idealCycleTime}
                        onChange={props.onNumericChange}
                    />
                </Box>
                <Box sx={{width: 400}}>
                    <AxionControls.AxionTextBox 
                        name="cavities"
                        label={<FormattedMessage {...messages.cavitiesColumnLabel} />}
                        value={props.productionItem.cavities}
                        onChange={props.onNumericChange}
                    />
                </Box>
                <Box>
                    <Controls.Checkbox 
                        name="isPriorityItem"
                        label={<FormattedMessage {...messages.isPriorityItemColumnLabel} />}
                        value={props.productionItem.isPriorityItem}
                        onChange={props.onChange}
                    />
                </Box>
               <Box>
                    <Button 
                        variant="contained" 
                        sx={{
                            marginTop: 2,
                            }}
                        onClick={props.handleSave}>
                        <FormattedMessage {...messages.save} />
                    </Button>
                </Box>
        </Box>
    );
}